<i18n lang='yml' src='../i18n/SkillSetsListing.yml'></i18n>
<template>
  <div>
    <div class="heading-block mb-0 d-flex">
      <h4>
        <span class="apprentice-name" v-if="allow_approval == 'true' && logbookData && logbookData.user_identity.external_identifiers">
          {{logbookData.user_identity.last_name}}, {{logbookData.user_identity.first_name}} ({{logbookData.user_identity.external_identifiers.sto_id}})
        </span>
        <span class="program-name"> {{parent_name}} {{!logbookData ? $t('management') : "" }}</span> 
      </h4>
      <a v-if="edit == 'true'" class='btn btn-sm btn-success ml-auto' :href="new_skill_set_path">
        <font-awesome-icon :icon="['fa', 'plus']"/>
        {{ $t('new_skill_set') }}
      </a>
    </div>
    <div v-if="edit == 'true'">
      <h5 class="margin-top heading-page">
        {{$t('subheader')}} 
      </h5>
      <p class="border-bottom"> {{$t('info', { standard: parent_name })}}</p>
    </div>
    <div v-if="logbookData" :class="allow_approval == 'true' ? 'mb-0' : ''" class="heading-block post-meta top-shadow"> 
      <ul class="list-inline list-annotation has-select-input">
        <li class="progress-component" v-if="logbookData.get_tracking_information.skills_tracking">
          <progress-bar 
              :percentage_value="logbookData.get_progress.percent" 
              :approved="logbookData.get_progress.completed_count"
              :total="logbookData.get_progress.mandatory_count"
              progress_message='progress-message-skills'
              type="success">
          </progress-bar>
        </li>   
        <li class="progress-component" v-if="logbookData.get_tracking_information.hours_tracking">
          <progress-bar 
            :percentage_value="logbookData.get_hour_progress.percent"
            :approved="logbookData.get_hour_progress.completed_hours"
            :total="logbookData.get_hour_progress.required_hours"
            progress_message='progress-message-hours'
            type="custom">
          </progress-bar>
        </li>
        <!-- Logbook Approval -->
        <li v-if="allow_approval == 'true'" class="ml-md-auto select-input-wrap">
          <div class="input-group input-group-sm">
            <select :disabled="logbookData.status == 'incomplete'" ref="dropdown_logbook_approval" id="dropdown_logbook_approval" :name="$t('dropdown_logbook_approval')" class="select-dropdown custom-select form-control-sm" v-model="logbookUpdateStatus">
              <option :value="null" disabled>{{$t('select_logbook_status')}}</option>
              <option value='meets_requirements' :disabled="!isLocked">
                {{ $t('logbook_unapprove') }}
              </option>
              <option value='approved' :disabled="logbookData.status != 'meets_requirements'">
                {{ $t('logbook_approve') }}
              </option>
            </select>
            <div class="input-group-append">
              <button :disabled="logbookData.status == 'incomplete'" class="btn btn-sm btn-success" href="#" @click="submitLogbookStatusChange()">
                {{ $t('save') }}
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>
    
    <div v-if=" logbookData" class="heading-block post-meta">
      <ul class="list-inline list-annotation has-select-input"> 
        <li>{{ $t('logbook_status') }}
          <span class="status-badge">
            {{ $t(logbookData.status) }}
          </span>
        </li>
        <li>{{ $t('last_updated') }} {{ formatDate(logbookData.get_last_update)}}</li>
        <!-- skillset Approval -->
        <li class="ml-md-auto select-input-wrap">
          <div class="btn-group d-sm-none mr-2">
            <a v-if='!isAllSetsSelected' :disabled="isLocked" class="btn btn-outline-secondary " href="#" @click="selectAll()">
              {{ $t('select_all') }}
            </a>
            <a v-else :disabled="isLocked" class="btn btn-outline-secondary" href="#" @click="deselectAll()">
              {{ $t('deselect_all') }}
            </a>
          </div>
          <div class="input-group input-group-sm">
            <select :disabled="isSkillSetDisabled || isLocked || (!allMeetRequirements && !allApproved)" ref="dropdown_skillset_approval" id="dropdown_skillset_approval" :name="$t('dropdown_skillset_approval')" class="select-dropdown custom-select form-control-sm" v-model="bulkUpdateStatus">
              <option :value="null" disabled>{{$t('select_status')}}</option>
              <option v-bind:key="item.value" v-for='item in skillSetStatuses' :value="item" :disabled="item.approve ? !allMeetRequirements : !allApproved">
                {{ item.approve ? $t('approve') : $t('unapprove') }}
              </option>
            </select>
            <div class="input-group-append">
              <button :disabled="isSkillSetDisabled || isLocked || (!allMeetRequirements && !allApproved)" class="btn btn-sm btn-success" href="#" @click="submitBulkStatusChange()">
                {{ $t('save') }}
              </button>
            </div>
          </div>
          <div class="btn-group d-none d-sm-block ml-2">
            <a v-if='!isAllSetsSelected' :disabled="isLocked || (!allSkillSetsMeetRequirements && !allSkillSetsApproved)" class="btn btn-outline-secondary" href="#" @click="selectAll()">
              {{ $t('select_all') }}
            </a>
            <a v-else :disabled="isLocked || (allSkillSetsMeetRequirements && allSkillSetsApproved)" class="btn btn-outline-secondary" href="#" @click="deselectAll()">
              {{ $t('deselect_all') }}
            </a>
          </div>
        </li>
      </ul>
    </div>
    <filter-bar :filter_params = filter_params :filter_path = filter_path></filter-bar>
    <div class="alert alert-danger" role="alert" v-if="error">
      <h5>{{ $t('loading_error') }}</h5>
    </div>
    <div v-else-if="skillSetsList.length == 0">
      <div class="alert alert-warning" role="alert">
        {{noDataError}}
      </div>
    </div>
    <div class="content-block content-block-logbook" v-else :key="skillSet.id" v-for="skillSet in skillSetsList">
      <div class="post-meta" v-if="!skillSet.required || isApprover || !logbookData">
        <ul class="list-inline list-annotation">
          <li class="list-inline-item pt-0" v-if="!skillSet.required">
            <span class="badge yellow-bg">{{ $t('optional') }}</span>
          </li>
          <li class="list-inline-item ml-auto" v-if="logbookData && isApprover" >
            <label :for="`select-skill-set-${skillSet.id}`" class="check-select">
              <input :disabled="isLocked || isApproved(skillSet)" :id="`select-skill-set-${skillSet.id}`" v-model="bulkUpdateSkillSets" type="checkbox" :value="skillSet.id" /> 
              <span>{{ $t('select') }}</span>
            </label>
          </li>
          <li class="list-inline-item ml-auto" v-if="!logbookData" >
            <div v-if="edit =='true'" class="btn-group btn-group-sm ml-auto">
              <a class="btn btn-outline-primary" :href="`skill_sets/${skillSet.id}/edit`">
                <font-awesome-icon :icon="['fas', 'edit']" />
                {{ $t('edit') }}
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div class="post-view">
        <div class="post-content"  >
          <div class="view-area">
            <h5 class="mb-0" :class="logbookData ? 'heading-content' : 'container-item-name'">
              <a :href="`skill_sets/${skillSet.id}/skills`">{{ skillSet.skill_set_code }} - {{ skillSet.name[locale] }}</a>
            </h5>
            <div v-if="!logbookData && skillSet.description[locale] && skillSet.description[locale].length > 0" class="fr-view description clearfix">
              <more-less :descriptionText="skillSet.description[locale]" />
              <span class="sr-only" v-html="skillSet.description[locale]"></span>
            </div>
          </div>
        </div>
      </div>
      <hr class="m-0"/>
      <div class="post-meta" v-if="logbookData">
        <ul class="list-inline list-annotation">
         <li>
          <span class="wrap-items">{{ $t('status') }} 
            <span class="status-badge">
              {{ skillSetStatusMapping[`skill_set_${skillSet.id}_status`] ? skillSetStatusMapping[`skill_set_${skillSet.id}_status`].name : $t('incomplete')}}
            </span>
          </span>       
          <span class="wrap-items" v-if="skillSet.status">{{ $t('last_updated') }} {{ formatDate(skillSet.status.updated_at)}}</span>
          </li>
          <li v-if="skillSet.progress" class="progress-component">
            <progress-bar 
              :percentage_value="skillSet.progress.percent" 
              :approved="skillSet.progress.completed_count" 
              :total="skillSet.progress.mandatory_count" 
              progress_message='progress-message-skills'
              type="success">
            </progress-bar>
          </li>
        </ul>
      </div>
      <div class="post-tabs" v-if="logbookData">
        <ul class="nav nav-tabs nav-tile" role="tablist">
          <li class="nav-item">
            <a class="nav-link" :href="`#history-${skillSet.id}`">
              <font-awesome-icon :icon="['fas', 'history']" />
              <span>{{$t('history')}}</span>
            </a>
          </li>
        </ul>
        <history-tab :item="skillSet" :locale="locale" :trainer_details="false"/>
      </div>
    </div>
  </div>
</template>
<script>
  import Main from '../../filter_bar/components/Main.vue';
  import LoadingAnimation from '../../shared/loader/components/LoadingAnimation.vue';
  import ProgressBar from '../../shared/progress_bar/ProgressBar.vue'
  import MoreLess from '../../shared/more_less_component/MoreLess.vue'
  import HistoryTab from './HistoryTab.vue'
  import { sendAjaxRequest } from '../../shared/typescripts/ajax.ts';
  import {formatDate} from '../../shared/typescripts/dates.ts'

  export default { 
    props: ['locale', 'parent_name', 'logbook', 'skill_sets', 'logbook_skill_set_statuses', 'skill_set_statuses', 'filter_params', 'filter_path', 'new_skill_set_path', 'skill_set_description', 'edit', 'allow_approval'],
    components: {
        'filter-bar': Main,
        'loading-animation': LoadingAnimation,
        'progress-bar': ProgressBar,
        'history-tab': HistoryTab,
        'more-less': MoreLess
    },
    data() {
      return {
        skillSetsList: [],
        logbookData: null,
        logbookUpdateStatus: null,
        skillSetStatuses: [],
        logbookSkillSetStatuses: [],
        skillSetStatusMapping: {},
        bulkUpdateSkillSets: [],
        bulkUpdateStatus: null,
        error: false,
        loading: false,
      }
    },
    computed: {
      isSkillSetDisabled: function() {
        return this.bulkUpdateSkillSets.length === 0;
      },
      isLocked: function() {
        return this.logbookData.status == 'approved';
      },
      isApprover: function() {
            
        return this.allow_approval == 'true';
      },
      isAllSetsSelected: function() {
        let result = true
        if(this.bulkUpdateSkillSets.length == 0) {
          result = false
        }
        return result
      },
      // Determine if all selected skill sets are in meets requirements
      allMeetRequirements: function() {
        return this.checkbulkUpdateSkillSets('request_approval')
      },      
      // Determine if all selected skill sets are in meets requirements
      allApproved: function() {
        return this.checkbulkUpdateSkillSets('approve')   
      },
      allSkillSetsMeetRequirements: function() {
        return this.checkbulkUpdateSkillSets('request_approval')
      },
      // Determines if all the skill sets are approved in order to allow logbook approval
      allSkillSetsApproved: function() {
        return this.checkbulkUpdateSkillSets('approve')
      },
      noDataError: function() {
        let params;
        try {
          params = JSON.parse(this.filter_params)
          if (params){
            return params['search'].value ? this.$t('no_search') : this.$t('no_data') ;
          }
        }
        catch(err) {
        this.error = true;  
        }    
      }
    },
    mounted() {
      // Here we are handling all of the mapping between the JSON objects we are getting as params to our variables
      // Some of them are dependent on whether we are inside of a logbook
      try {
        this.logbookData = this.logbook ? JSON.parse(this.logbook) : null
        this.skillSetsList = JSON.parse(this.skill_sets) || [];
        if(this.logbookData) {
          this.logbookSkillSetStatuses = JSON.parse(this.logbook_skill_set_statuses) || [];
          this.skillSetStatuses = JSON.parse(this.skill_set_statuses) || [];
          this.skillSetStatusMapping = this.initStatusMapping()
        }
      }
      catch(err) {
        this.error = true;
      }
    },
    methods: {
      // Determines if a skill set is approved in order to disable or enable certain buttons
      isApproved(skill_set) {
          var status = skill_set.status ? this.getStatus(skill_set.status.skill_set_status_id) : null        
          return status && status.skill_set_status && status.skill_set_status.approved && this.allow_approval == 'false'
      },
      // Gets the SkillSetStatus object based on the given id
      getStatus(skill_set_status_id) {
        return this.skillSetStatuses.find((status) => {
          return status.value == skill_set_status_id
        }) || null      
      },
      // An array containing for each skill set either the existing progress or null
      // Used to map the skill sets to progresses for viewing and saving
      initStatusMapping() {
        var result = {}

        this.skillSetsList.forEach((skill_set) => {
          // Map the status for this logbook to the skill set
          skill_set.status = this.logbookSkillSetStatuses.find((logbookSkillSetStatus) => {
            return logbookSkillSetStatus.skill_set_id == skill_set.id
          }) || null

          skill_set.trainer_details = skill_set.status && skill_set.status.trainer_details ? skill_set.status.trainer_details : {}

          var status = skill_set.status ? this.getStatus(skill_set.status.skill_set_status_id) : null
          // Map the skill_set_status to the dropdown option
          result[`skill_set_${skill_set.id}_status`] = status ? {
            name: status.name,
            value: status.value,
            approved: status.approved,
            request_approval: status.request_approval
          } : null
        })
        return result
      },
      // Updates the skill sets status in the mapping so we can save it properly
      updateSkillSetStatus(status, skill_set_id) {
        this.skillSetStatusMapping[`skill_set_${skill_set_id}_status`] = status;
      },
      //TODO: Revisit to standardize
      // Used for turning our system dates into a standard human readable format
      formatDate(dateString) {
        return formatDate(dateString)
      },
      // Submits a change for the logbook status
      submitLogbookStatusChange(){
        if(!this.logbookUpdateStatus) {
          return
        }
        var message = this.$t('logbook_approval_attestation')
        // Confirmation message
        if(this.logbookUpdateStatus == 'meets_requirements') {
          message = this.$t('confirm_revoke_logbook_approval')
        }
        // Confirmation
        if(!confirm(message)) {
          return
        }
        var current_url = window.location.href
        this.loading = true
        var method= 'PUT'
        var url= current_url.substring(0, current_url.lastIndexOf("/"));
        var data= {
          logbook_statuses: {
            status: this.logbookUpdateStatus,
          }
        }
        sendAjaxRequest(method, url, 'json', data, this.ajaxSuccess, this.ajaxAlertError)
      },
      // Get all the Skill Set codes from the bulkUpdate list
      getSkillSetCodes() {
        var skillSets = []
        this.bulkUpdateSkillSets.forEach((skill_set_id) => {
          var foundSkillSet = this.skillSetsList.find((skill_set) => {
            return skill_set.id == skill_set_id
          })
          skillSets.push(foundSkillSet.skill_set_code)
        })
        return skillSets

      },
      // Submits all the selected skill sets for a bulk status change
      submitBulkStatusChange() {
        if(!this.bulkUpdateStatus || this.bulkUpdateSkillSets.length == 0) {
          return
        }
        if(this.bulkUpdateStatus.request_approval) {
          var skillSets = this.getSkillSetCodes();
          if(!confirm(this.$t('confirm_revoke_skill_set_approval', {skill_sets: skillSets.join('\n')}))) {
            return
          }
        }
        this.loading = true
        var method= 'POST'
        var url= `bulk_skill_sets_status_update`
        var data= {
          logbook_skill_set_statuses: {
            skill_set_status_id: this.bulkUpdateStatus.value,
            skill_sets: this.bulkUpdateSkillSets,
            logbook_id: this.logbookData.id
          }
        }
        sendAjaxRequest(method, url, 'json', data, this.ajaxSuccess, this.ajaxAlertError)

      },
      // Selects all the skill sets on the page and add them to the bulk skill sets list
      selectAll() {
        this.skillSetsList.forEach((skillSet) => {
          if(this.bulkUpdateSkillSets.indexOf(skillSet.id) == -1) {
            this.bulkUpdateSkillSets.push(skillSet.id)
          }
        })
      },
      // Deselect all the skill sets on the page from the bulk skill sets list
      deselectAll() {
        this.bulkUpdateSkillSets = []
      },
      checkbulkUpdateSkillSets: function(statusType) {
        var skillSetIdList = []
        var result = true
        this.skillSetsList.forEach((skillSet) => skillSetIdList.push(skillSet.id))
        var bulkUpdateSkillSets = this.bulkUpdateSkillSets.length == 0?  skillSetIdList : this.bulkUpdateSkillSets;
        
        bulkUpdateSkillSets.forEach((skillSetId) => {
         var skillSet = this.skillSetsList.find((skillSet) => {
            return skillSet.id == skillSetId
          })
          var status = skillSet.status ? this.getStatus(skillSet.status.skill_set_status_id) : null  
          if (statusType == 'request_approval'){
            if(!status || !status.request_approval) {
              result = false
            }
          }
          else {
            if(!status || !status.approve) {
              result = false
            }
          }
        })
        return result
      },
      

      // Submits any change to the skill set status
      submitStatusChange(skill_set_id) {
        this.loading = true;
        var skill_set = this.skillSetsList.find((skill_set) => {
          return skill_set.id == skill_set_id
        })
        var method = skill_set.status ? "PUT" : "POST"
        var url= skill_set.status ? `skill_sets/${skill_set_id}/logbook_skill_set_statuses/${skill_set.status.id}` : `skill_sets/${skill_set_id}/logbook_skill_set_statuses`
        var data = {
          logbook_skill_set_status: {
            skill_set_status_id: this.skillSetStatusMapping[`skill_set_${skill_set_id}_status`].value,
            skill_set_id: skill_set_id,
            logbook_id: this.logbookData.id,
            trainer_details: skill_set.trainer_details
          }
        }
        sendAjaxRequest(method, url, 'json', data, this.ajaxSuccess, this.ajaxAlertError)
      },

      ajaxSuccess() {
        this.loading = false;
        window.location.reload();
      },

      ajaxAlertError() {
        this.loading = false;
        alert(this.$t('saving_error'));
      }
    }
  }
</script>
